var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { range } from '~utils/range';
import { name } from './constants';
var initialState = {
    data: [],
    meta: {
        order: range(10),
        langIso: '',
    },
    loading: 'idle',
    error: null,
};
export var markets = createSlice({
    name: name,
    initialState: initialState,
    reducers: {
        switchPlaces: function (state, _a) {
            var payload = _a.payload;
            var a = payload.a, b = payload.b;
            var prevOrder = state.meta.order;
            var order = __spreadArray([], prevOrder, true);
            order[a] = prevOrder[b];
            order[b] = prevOrder[a];
            state.meta.order = order;
        },
        getMainColumnsInfoPending: function (state) {
            state.loading = 'pending';
            state.error = null;
        },
        getMainColumnsInfoSuccess: function (state, _a) {
            var payload = _a.payload;
            state.loading = 'fulfilled';
            state.data = payload.data;
            state.meta.langIso = payload.langIso;
            state.error = null;
        },
        getMainColumnsInfoError: function (state, action) {
            state.loading = 'rejected';
            state.error = action.payload;
        },
    },
});
export var getMainColumnsInfoPending = (_a = markets.actions, _a.getMainColumnsInfoPending), getMainColumnsInfoSuccess = _a.getMainColumnsInfoSuccess, getMainColumnsInfoError = _a.getMainColumnsInfoError, switchPlaces = _a.switchPlaces;
